import React from "react";
import { useLocation } from "react-router-dom";
//#region types
import { NavigationListItemContentProps } from "models/propTypes/navListPropTypes";
//#endregion
//#region components
import { Link } from "react-router-dom";
import { Grid, ListItem } from "@mui/material";
import NavigationSubItemMenu from "./subItemMenu";
import { Icon, RoundButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance } from "utils/helpers";

const NavigationRootItem: React.FC<NavigationListItemContentProps> = (props) => {
  const location = useLocation();

  const forwardNavLink = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, any>((linkProps, ref) => (
        <Link to={props.path} {...linkProps} ref={ref as any} />
      )),
    [props.path]
  );

  const checkIfMatch = () => {
    const url = location.pathname;
    const parentUrl = location.pathname.replace(url.split("/").slice(-1).toString(), "");

    if (props.activeWithDirectChild) {
      return (
        url === props.path || url === `${props.path}/` || parentUrl === props.path || parentUrl === `${props.path}/`
      );
    }

    return url === props.path || url === `${props.path}/`;
  };

  const [activeRoute, setActiveRoute] = React.useState<any>(checkIfMatch());

  React.useEffect(() => {
    if (props.children ? location.pathname.startsWith(props.path) : checkIfMatch()) {
      setActiveRoute(true);
    } else {
      setActiveRoute(false);
    }
  }, [props.path, location.pathname]);

  return (
    <ListItem
      id={props.id}
      button
      key={props.id}
      className={clsx(
        props.children ? cssExports.navListItemWithMenuIcon : "",
        cssExports.navListItem,
        activeRoute ? cssExports.navListItemActive : "",
        !props.root ? cssExports.subNavItem : ""
      )}
      component={props.children ? "div" : forwardNavLink}
      selected={activeRoute}
      disableRipple={true}
    >
      <Grid item container spacing={1} alignItems="center" wrap="nowrap">
        {props.root && (
          <Grid item>
            {
              // eslint-disable-next-line eqeqeq --- since checked against different types
              props.collapsed && props.children != undefined ? (
                <Grid item className={cssExports.navListItemMenuIcon}>
                  <NavigationSubItemMenu {...props} />
                </Grid>
              ) : (
                <>
                  {
                    // eslint-disable-next-line eqeqeq --- since checked against different types
                    !props.collapsed && props.children != undefined ? (
                      <RoundButton size="xs">
                        <Icon icon={props.icon} className={cssExports.navListIcon} />
                      </RoundButton>
                    ) : (
                      <Icon icon={props.icon} className={clsx(cssExports.navListIcon, cssExports.rootIcon)} />
                    )
                  }
                </>
              )
            }
          </Grid>
        )}
        <Grid item className={props.root ? cssExports.navListRootText : cssExports.navListText}>
          {LocalizationHelperInstance.getFormattedMessage(props.displayText)}
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default NavigationRootItem;
